module.exports = __webpack_public_path__ + "assets/tailwind-css.a2589df1.svg";